import React, { Component } from 'react';

export default class SeniorenplatformItem extends Component {
    constructor(props){
        super();     

        this.isExternal = props.isExternal ? props.isExternal : false;
        this.isTechnicalExercise = props.isTechnicalExercise ? props.isTechnicalExercise : false;
        this.showDetails = this.showDetails.bind(this);
    }

    showDetails(){
        if(this.isExternal){
            let curPath = this.props.exerciseLocation;
            const urlName = `${curPath}exercise/${this.props.item.urlName}/`;
            window.location = urlName;            
        }
        else{
            this.props.getDetailsOfItem(this.props.item.urlName)
        }
    }
    toggleIsFavorites = (event) => {
        event.stopPropagation();
        this.props.toggleIsFavorites(this.props.item);
    }

    render() {
        
        return (
            this.props.item && <div className={`c-senioren__item ${this.isExternal ? "c-senioren__item--external" : ""}`}  onClick={this.showDetails}>
            <div className="c-senioren__banner">
                {this.props.item.thumbnailUrl !== null && this.props.item.thumbnailUrl !== "" ?
                    <img src={`${this.props.item.thumbnailUrl}`} data-src={`${this.props.item.thumbnailUrl}?width=480?height=360`} data-umbracofocalpoint="true" data-focal-left="0.5"
                    data-focal-top="0.5" data-quality="70"/> :
                    <img data-src="/img/no-image.png" data-umbracofocalpoint="true" data-focal-left="0.5"
                    data-focal-top="0.5" data-quality="70"/>
                }
                <div className="play-button">
                    <div className="play-button__icon"></div>
                </div>
            </div>
            <div className="c-senioren__content">
                <div className="c-senioren__content-title">
                    <h4>{this.props.item.name}</h4>
                    <div className={`c-senioren__button c-senioren__button--favorite ${this.props.item.isFavorite === true ? "c-senioren__button c-senioren__button--favorite--active" : ""}`}
                         onClick={this.toggleIsFavorites}
                         >
                        <div className="icon">
                            {this.props.item.isFavorite !== null && this.props.item.isFavorite !== true ? 
                                <i className="fa-regular fa-heart"></i>
                                : 
                                <i className="fa-solid fa-heart"></i>                                                          
                            }   
                        </div> 
                    </div>
                </div> 
                { this.isTechnicalExercise &&
                    <a className={`minimal c-link--icon`} title="Bekijk de oefening">
                        Bekijk de oefening<i className="fa-solid fa-arrow-right"  aria-hidden="true"></i>
                    </a>    
                }
                                      
            </div>
        </div>
        );
    }
}